import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

// Isti izgled kao datum u pretrazi (TripSearchForm.inputSx) — jedan dizajn svuda.
const baseSx = {
    "& .MuiOutlinedInput-root": {
        borderRadius: 2,
        bgcolor: "grey.50",
        height: 52,
    },
    "& .MuiInputLabel-root": {
        fontSize: "0.9rem",
    },
};

/**
 * Jedinstveni izbor datuma za celu aplikaciju: MUI kalendar u dizajnu forme za
 * pretragu (umesto browserskog type="date" koji izgleda različito po browseru).
 * Vrednost je string "YYYY-MM-DD" ili "" — isti ugovor kao native input, pa je
 * zamena bezbolna. `sx` se primenjuje POSLE osnovnog stila (za odstupanja tipa
 * bele pozadine ili niže visine u redu filtera).
 */
export default function AppDatePicker({
    label,
    value,
    onChange,
    minDate,
    maxDate,
    disablePast = false,
    clearable = false,
    sx,
}) {
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
                label={label}
                value={value ? dayjs(value) : null}
                onChange={(val) => onChange(val && val.isValid() ? val.format("YYYY-MM-DD") : "")}
                minDate={minDate ? dayjs(minDate) : undefined}
                maxDate={maxDate ? dayjs(maxDate) : undefined}
                disablePast={disablePast}
                format="DD.MM.YYYY"
                slotProps={{
                    textField: {
                        size: "small",
                        fullWidth: true,
                        sx: [baseSx, ...(Array.isArray(sx) ? sx : [sx])].filter(Boolean),
                    },
                    field: clearable ? { clearable: true } : undefined,
                }}
            />
        </LocalizationProvider>
    );
}
